import { Injectable } from '@angular/core';
//import { HttpClient,HttpErrorResponse,HttpHeaders } from '@angular/common/http';
import {HttpService} from '../../core/lib/http.service'
import { tokenName } from '@angular/compiler';
import { environment } from '../../../environments/environment';

import { CompanyService } from '../../services/Company/company.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

    private apiurl = "";

    private tokenkey = "_authtoken";
    private userkey = "_zerome";
     
    constructor(private httpservice: HttpService,private companyService:CompanyService) {
        this.apiurl = environment.apiUrl;
        console.log('CUR ' + this.apiurl)
    }
    


    async login1(mobile:string,password:string,callback:any) {

        let that = this;

        this.httpservice.post(this.apiurl + '/v3/admin/login',{'email':mobile,'password':password}).subscribe((data:any)=>{

            let result = {};

            callback(data);
            /*if (data.access_token) {
                localStorage.setItem(this.tokenkey, data.access_token);   
            
                that.getAuthUser(function(user:any){

                    localStorage.setItem(this.userkey, JSON.stringify(user));

                });

                result = {status:'OK'};
            }
            else if (data.token) {
                let token = data.token.access_token;

                localStorage.setItem(this.tokenkey, token);

                if (data.me) {
                    localStorage.setItem(this.userkey, JSON.stringify(data.me));
                }

                result = {status:'OK'};

            }
            else {
                result = {status:'error','message':data};
            }

            callback(result);*/

        },(err:any)=>{
            
            let result = {status:'error','message':err.error};
            console.log('ERR: ' + JSON.stringify(err))
            callback(result);
        }
        
        );

    }

    login(mobile:string,password:string) {
        return this.httpservice.post(this.apiurl + '/v3/admin/login',{'email':mobile,'password':password});
    }


    update(data:object) {
        return this.httpservice.post(this.apiurl + '/v3/account/update',data);
    }

    logout() {
        localStorage.clear();
        sessionStorage.clear();

        this.companyService.clearDefault();

        //$window.location.reload();
        window.location.replace("/");
    }


    public getCurrentUser() {
        
        //const userdata = localStorage.getItem(this.userkey);
        const userdata = sessionStorage.getItem(this.userkey);

        //console.log('ERR: ' + userdata);
        //alert(userdata);

        if (userdata) {
            return JSON.parse(userdata);
        }

        return null;
    }


    public isAuthenticated(): boolean {

        const token = this.getAccessToken();
    

        if (token!=null && token!='' && token.length>0)
            return true;
        
        return false;
    }


    public getAccessToken() {
        return sessionStorage.getItem(this.tokenkey);  //localStorage.getItem(this.tokenkey);
    }


    async getAuthUser(callback) {
        /*this.httpservice.get('/api/user',{}).subscribe((data:any)=>{
            callback(data);
        });*/
        return await this.httpservice.get('/api/user',{});
            
    }


    public setSession(user:any) {
        if (user) {

            let key = user.access_token;
            let data = JSON.stringify(user);

            //localStorage.setItem(this.userkey,data);
            sessionStorage.setItem(this.userkey,data);

            //localStorage.setItem(this.userkey,data);
            sessionStorage.setItem(this.tokenkey,key);
        }
    }


    async requestResetPassword(email:string) {
        return await this.httpservice.post1(this.apiurl + '/v3/forgetpasswd/',{'email':email});
    }


    async ResetPassword(token:string, newpass:string) {
        return await this.httpservice.post1(this.apiurl + '/v3/resetpass/' + token,{'newpass':newpass});
    }

    verifyResetToken(token:string) {
        return this.httpservice.post(this.apiurl + '/v3/verifyreset',{'token':token});
    }


    async signin(mobile:string,password:string) {
        return await this.httpservice.post1(this.apiurl + '/v3/signin',{'email':mobile,'password':password});
    }


    resend(data:object) {
        return this.httpservice.post(this.apiurl + '/v3/acct/resendVerify/',data);
    }

    verifyPhone(mobile:string) {
        return this.httpservice.get( 'https://dev.codezero.app/api/v2/user/signup/phone-verify',{'mobile':mobile});
    }


    verifyOtp(mobile:string) {
        return this.httpservice.post( 'https://dev.codezero.app/api/v2/user/verify-otp',{'mobile':mobile});
    }

    sendOtp(mobile:string) {
        return this.httpservice.post( 'https://dev.codezero.app/api/one_time_pin',{'mobile':mobile,'type':1});
    }

    submitZSignup(token,data:object) {
        
        return this.httpservice.post( this.apiurl + '/v3/auth/zsignup/'+token,data);
    }

    submitZlogin(token,data:object) {
        
        return this.httpservice.post( this.apiurl + '/v3/auth/zsignin/'+token,data);
    }
}
